import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Menu,
  Typography,
  Paper,
  List,
  ListItemButton,
  Divider,
} from "@mui/material";
import { ArrowDropDown, EventNote, History } from "@mui/icons-material";
import BuildTemplateModal from "../PopupModal/BuildTemplateModal";

const BuildHistory = ({
  buildHistory,
  selectedDate,
  setSelectedDate,
  selectedSublocation,
  setSelectedSublocation,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showBuildModal, setShowBuildModal] = useState(false);
  const [date, setDate] = useState(new Date());
  const [sublocation, setSublocation] = useState(null);

  const todayStr = new Date().toISOString().split("T")[0];

  // অটো-সিলেক্ট লজিক: পেজ লোড হলে আজকের ডাটা সিলেক্ট হবে
  useEffect(() => {
    if (buildHistory && buildHistory.length > 0) {
      const todaySchedule = buildHistory.find((item) => item.date === todayStr);
      
      // যদি আজকে থাকে তবে আজকে, নাহলে একদম লেটেস্ট ডাটা সিলেক্ট হবে
      const target = todaySchedule || buildHistory[0];

      if (target && target.sublocations.length > 0 && !sublocation) {
        const defaultSub = target.sublocations[0];
        setSelectedDate(target.date);
        setSelectedSublocation(defaultSub.id);
        setDate(target.date);
        setSublocation(defaultSub);
      }
    }
  }, [buildHistory, todayStr, setSelectedDate, setSelectedSublocation, sublocation]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (sublocation, date) => {
    setSelectedDate(date);
    setSelectedSublocation(sublocation.id);
    setDate(date);
    setSublocation(sublocation);
    handleMenuClose();
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        style={{ minWidth: 300 }}
        endIcon={<ArrowDropDown />}
        onClick={handleMenuOpen}
        sx={{ textTransform: "none", padding: "8px 12px" }}
      >
        {date && sublocation ? (
          <>
            {new Date(date).toLocaleDateString("en-GB")} - {sublocation.name} -{" "}
            {sublocation.template ? sublocation.template.name : "Click to build"}
          </>
        ) : (
          "Select a schedule"
        )}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        // ড্রপডাউন মেনুর উচ্চতা বাড়িয়ে দেওয়া হয়েছে যাতে অনেক ডাটা দেখা যায়
        PaperProps={{
          style: {
            maxHeight: 500, 
            width: 320,
          },
        }}
      >
        <Paper sx={{ padding: 1 }}>
          <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: "bold", display: 'flex', alignItems: 'center', gap: 1 }}>
             Schedules History
          </Typography>
          <Divider />
          
          <List>
            {buildHistory?.length > 0 ? (
              buildHistory.map((schedule) => (
                <div key={schedule.date}>
                  {/* তারিখের হেডার */}
                  <Typography
                    variant="caption"
                    sx={{ 
                      fontWeight: "bold", 
                      paddingX: 2, 
                      paddingY: 1,
                      display: 'block',
                      bgcolor: schedule.date === todayStr ? "#e3f2fd" : "#f5f5f5",
                      color: schedule.date === todayStr ? "primary.main" : "text.secondary"
                    }}
                  >
                    {new Date(schedule.date).toLocaleDateString("en-GB")}
                    {schedule.date === todayStr ? " (Today)" : " (Previous)"}
                  </Typography>

                  {schedule.sublocations.map((sub) => (
                    <ListItemButton
                      key={sub.id}
                      selected={sublocation?.id === sub.id && date === schedule.date}
                      onClick={() =>
                        sub.template
                          ? handleSelect(sub, schedule.date)
                          : (() => {
                              setSelectedSublocation(sub);
                              setShowBuildModal(true);
                              setSelectedDate(schedule.date);
                              handleMenuClose();
                            })()
                      }
                      sx={{ paddingY: 0.5 }}
                    >
                      <EventNote fontSize="small" sx={{ marginRight: 1, color: sub.template ? 'primary.main' : 'action.disabled' }} />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: sublocation?.id === sub.id ? 'bold' : 'normal' }}
                      >
                        {sub.name} - {sub.template ? sub.template.name : "Build Needed"}
                      </Typography>
                    </ListItemButton>
                  ))}
                  <Divider />
                </div>
              ))
            ) : (
              <Typography variant="body2" sx={{ p: 2, textAlign: 'center' }}>
                No history found
              </Typography>
            )}
          </List>
        </Paper>
      </Menu>

      <BuildTemplateModal
        show={showBuildModal}
        handleClose={() => {
          setShowBuildModal(false);
          setSelectedSublocation(null);
        }}
        sublocation={selectedSublocation}
        date={selectedDate}
      />
    </div>
  );
};

export default BuildHistory;
